// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeSunbit_titleIcon__1jS6U","inputPhoneContainer":"ViewChargeSunbit_inputPhoneContainer__Qmi8Q"};